import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './About.css';

const About = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section className="about" id="about" ref={ref}>
      <div className="container">
        <div className="about-content">
          <motion.div 
            className="about-text"
            initial={{ opacity: 0, x: -50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
          >
            <h2>Experience Excellence in Dental Care</h2>
            <div className="about-description">
              <p>
                At Premier Dental Clinic, located in the heart of Ram Devi Complex, Suryabinayak, Bhaktapur, we have established ourselves as the most trusted and preferred dental care provider in the region. Our clinic stands out as the best dental clinic in Bhaktapur by offering painless, affordable, and exceptionally high-quality dental treatments using cutting-edge modern dental technology and maintaining international hygiene standards.
              </p>
              <p>
                What makes us special is our commitment to providing comprehensive dental care in a peaceful and comfortable environment. Our experienced team of dental professionals is dedicated to ensuring that every patient receives personalized attention and the highest standard of care. We are particularly trusted by locals throughout Bhaktapur for our expertise in root canal treatment, dental implants, braces, teeth cleaning, cosmetic dentistry, and full-mouth restoration.
              </p>
              <p>
                Our convenient location makes us easily accessible to patients from Suryabinayak, Katunje, and all surrounding areas of Bhaktapur. We understand that dental anxiety is common, which is why we've created a serene atmosphere combined with gentle, painless treatment techniques that help our patients feel relaxed and comfortable throughout their visit. Choose Premier Dental Clinic for a dental experience that combines modern excellence with compassionate care.
              </p>
            </div>
          </motion.div>
          
          <motion.div 
            className="about-image"
            initial={{ opacity: 0, x: 50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <img 
              src="/reception.jpeg" 
              alt="Premier Dental Clinic Reception Area"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
